import styled from 'styled-components'
import media from 'src/styles/media'

export const ProjetosListWrapper = styled.article`
    color: black;
    padding: 40px 0;

    ${media.lessThan('md')`
        padding-top: 30px;
    `}
`

export const ProjetosListContent = styled.div`
    padding-top: 60px;

    ${media.lessThan('md')`
        padding-top: 30px;
    `}
`